import React, { useCallback, useEffect, useState } from "react";
import { stats, sistemSagligi } from "../lib/api";
import { useAuth } from "../lib/auth";
import DashboardCorporate from "../components/dashboard/DashboardCorporate";

const PERIODS = [
    { id: "7d", label: "7g" },
    { id: "30d", label: "30g" },
    { id: "90d", label: "90g" },
    { id: "1y", label: "1y" },
];

export default function Dashboard() {
    const { user } = useAuth();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [period, setPeriod] = useState("30d");
    const [refreshAt, setRefreshAt] = useState(new Date());
    const [systemHealth, setSystemHealth] = useState(null);
    const [healthLoading, setHealthLoading] = useState(true);

    const userDisplay =
        data?.user_display || user?.first_name || user?.username || "Kullanıcı";

    const loadHealth = useCallback(async () => {
        setHealthLoading(true);
        try {
            const h = await sistemSagligi();
            setSystemHealth(h);
        } catch {
            setSystemHealth({ status: "warn", redis: { ok: false }, celery: { ok: false } });
        } finally {
            setHealthLoading(false);
        }
    }, []);

    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const d = await stats({ period });
            setData(d);
            setRefreshAt(new Date());
        } catch (e) {
            setError(
                e?.response?.data?.detail ||
                    e?.message ||
                    "İstatistikler yüklenemedi.",
            );
        } finally {
            setLoading(false);
        }
    }, [period]);

    useEffect(() => {
        load();
        loadHealth();
        const id = setInterval(() => {
            load();
            loadHealth();
        }, 90_000);
        return () => clearInterval(id);
    }, [load, loadHealth]);

    return (
        <DashboardCorporate
            data={data}
            loading={loading}
            error={error}
            period={period}
            setPeriod={setPeriod}
            PERIODS={PERIODS}
            load={load}
            refreshAt={refreshAt}
            userDisplay={userDisplay}
            systemHealth={systemHealth}
            healthLoading={healthLoading}
            onRefreshHealth={loadHealth}
        />
    );
}
